var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 34,
    viewBox: "0 0 54 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_368_7086)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M11.4069 33.0463C5.35034 33.0463 0.421753 28.0006 0.421753 21.7975C0.421753 15.5943 5.35034 10.5486 11.4069 10.5486C17.4635 10.5486 22.3921 15.5955 22.3921 21.7975C22.3921 27.9994 17.4635 33.0463 11.4069 33.0463ZM11.4069 13.0437C6.69329 13.0437 2.85945 16.9707 2.85945 21.7963C2.85945 26.622 6.69439 30.549 11.4069 30.549C16.1194 30.549 19.9544 26.622 19.9544 21.7963C19.9544 16.9707 16.1194 13.0437 11.4069 13.0437Z",
    fill: "#067DFD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M42.4366 33.0463C36.3789 33.0463 31.4514 27.9994 31.4514 21.7975C31.4514 15.5955 36.38 10.5486 42.4366 10.5486C48.4932 10.5486 53.4218 15.5955 53.4218 21.7975C53.4218 27.9994 48.4932 33.0463 42.4366 33.0463ZM42.4366 13.0437C37.723 13.0437 33.8891 16.9707 33.8891 21.7963C33.8891 26.622 37.7241 30.549 42.4366 30.549C47.1491 30.549 50.9841 26.622 50.9841 21.7963C50.9841 16.9707 47.1491 13.0437 42.4366 13.0437Z",
    fill: "#067DFD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M29.4791 22.6314H12.0008V20.1352H25.5566L18.6635 5.84436H14.8308V3.34814H20.1793L29.4791 22.6314Z",
    fill: "#067DFD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19.202 3.12573H14.7177C13.9834 3.12573 13.3881 3.73533 13.3881 4.48731V5.13519C13.3881 5.88716 13.9834 6.49676 14.7177 6.49676H19.202C19.9364 6.49676 20.5317 5.88716 20.5317 5.13519V4.48731C20.5317 3.73533 19.9364 3.12573 19.202 3.12573Z",
    fill: "#FF6A11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M35.5457 7.52588H21.5067V10.0221H35.5457V7.52588Z",
    fill: "#067DFD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M42.8233 23.0456C42.3845 23.0456 41.9613 22.8028 41.743 22.3773L31.5711 2.55168L27.5489 2.5982C27.5489 2.5982 27.5401 2.5982 27.5345 2.5982C26.8675 2.5982 26.3234 2.04903 26.3157 1.36371C26.3079 0.673845 26.8475 0.109927 27.5212 0.101984L32.2902 0.0463867C32.2902 0.0463867 32.2991 0.0463867 32.3035 0.0463867C32.7556 0.0463867 33.1711 0.302816 33.3828 0.713558L43.9003 21.2166C44.2139 21.827 43.9845 22.5816 43.3884 22.9015C43.2078 22.9991 43.0139 23.0445 42.8222 23.0445L42.8233 23.0456Z",
    fill: "#067DFD"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M11.4069 23.8252C12.5005 23.8252 13.387 22.9174 13.387 21.7976C13.387 20.6778 12.5005 19.77 11.4069 19.77C10.3133 19.77 9.42682 20.6778 9.42682 21.7976C9.42682 22.9174 10.3133 23.8252 11.4069 23.8252Z",
    fill: "#FF6A11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M27.5179 23.411C28.9193 23.411 30.0553 22.2477 30.0553 20.8127C30.0553 19.3777 28.9193 18.2144 27.5179 18.2144C26.1165 18.2144 24.9805 19.3777 24.9805 20.8127C24.9805 22.2477 26.1165 23.411 27.5179 23.411Z",
    fill: "#FF6A11"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M42.4366 23.8252C43.5302 23.8252 44.4167 22.9174 44.4167 21.7976C44.4167 20.6778 43.5302 19.77 42.4366 19.77C41.343 19.77 40.4565 20.6778 40.4565 21.7976C40.4565 22.9174 41.343 23.8252 42.4366 23.8252Z",
    fill: "#FF6A11"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_368_7086"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 33,
    fill: "white",
    transform: "translate(0.421753 0.0463867)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/싸이클.c7429c79b34331d5ebb5b77e862067db.svg";
export { ForwardRef as ReactComponent };